import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useHttpHook from "../../../../Hooks/HttpHook";
import { updCartData } from "../../../../ReduxSlice/Checkout/cartSlice";
import { GetCart, GetInstallmentsByEvent } from "../../../../utils/ApiConstant";
import { CartLanguage } from "../../../../utils/Languages";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import OrderSummamry from "./OrderSummary";
import AttendeeForm from "./AttendeeForm";
import AttendeeList from "./AttendeeList";

const AttendeeInformation = (props) => {
  const [loading, sendRequest, error] = useHttpHook();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [installment, setInstallment] = useState(null);
  const cart = useSelector((state) => state.cart);
  const EventData = useSelector((state) => state.event.data);
  const query = new URLSearchParams(window.location.search);
  const referralId = query.get("referralId");
  const tickets = cart?.data?.tickets || [];
  let redirectUrl = "/checkout/" + props.eventId;
  if (referralId) {
    redirectUrl += `?referralId=${referralId}`;
  }
  const getEmiInstallments = async () => {
    const response = await sendRequest(GetInstallmentsByEvent + props.eventId, {
      method: "get",
    });

    if (response.status === 1) {
      setInstallment(response.data);
    }
  };
  useEffect(() => {
    getCartData();
    getEmiInstallments();
  }, []);

  useEffect(() => {
    if (tickets.length > 0) {
      const pendingTicketStepIndex = tickets.findIndex(
        (ticket) => ticket.attendees.length < ticket.quantity
      );
      if (pendingTicketStepIndex !== -1) {
        setActiveTab(pendingTicketStepIndex);
      } else {
        setActiveTab((current) =>
          current === 0 ? 0 : tickets.length - 1
        );
      }
    }
  }, [cart]);

  const getCartData = async () => {
    const cartData = await sendRequest(GetCart + props.eventId, {
      method: "get",
    });

    if (cartData.status === 1) {
      dispatch(updCartData(cartData));
    }
  };

  const activeTicket = tickets[activeTab];
  const attendeesLeft = tickets.reduce((remaining, ticket) => {
    return remaining + Math.max(0, ticket.quantity - ticket.attendees.length);
  }, 0);

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-attendee-body">
        <div className="row g-4 g-xl-5 event-attendee-layout">
          <div className="col-lg-8">
            <div className="event-attendee-main">
              {tickets.length > 0 && (
                <>
                  <div className="event-attendee-scroll-shell event-attendee-scroll-shell--tabs">
                    <div className="event-attendee-tabs-wrap">
                      <div
                        className="event-attendee-tabs"
                        role="tablist"
                        aria-label="Ticket types"
                      >
                        {tickets.map((ticket, index) => (
                          <button
                            key={ticket.id || index}
                            type="button"
                            role="tab"
                            aria-selected={index === activeTab}
                            className={`event-attendee-tab${
                              index === activeTab ? " is-active" : ""
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            {ticket.name}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {activeTicket && (
                    <>
                      <div className="event-attendee-stats">
                        <span>
                          Total Attendees :{" "}
                          <strong>{activeTicket.quantity}</strong>
                        </span>
                        {activeTicket.attendees.length > 0 && (
                          <span>
                            Remaining Attendees :{" "}
                            <strong>
                              {activeTicket.quantity -
                                activeTicket.attendees.length}
                            </strong>
                          </span>
                        )}
                      </div>

                      <div className="event-attendee-content">
                        {activeTicket.attendees.length <
                          activeTicket.quantity && (
                          <AttendeeForm
                            eventId={props.eventId}
                            id={activeTicket.id}
                            getCartData={getCartData}
                          />
                        )}

                        {activeTicket.attendees?.length > 0 && (
                          <div className="event-attendee-scroll-shell event-attendee-scroll-shell--table">
                            <div className="event-attendee-table-wrap">
                              <table className="event-attendee-table">
                                <thead>
                                  <tr>
                                    <th scope="col">
                                      {CartLanguage.attendees.photo}
                                    </th>
                                    <th scope="col">
                                      {CartLanguage.attendees.name}
                                    </th>
                                    <th scope="col">
                                      {CartLanguage.attendees.email}
                                    </th>
                                    <th scope="col">
                                      {CartLanguage.attendees.dob}
                                    </th>
                                    <th scope="col">
                                      {CartLanguage.attendees.mobile}
                                    </th>
                                    <th scope="col">
                                      {CartLanguage.attendees.actions}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {activeTicket.attendees.map(
                                    (attendee, index) => {
                                      return (
                                        <AttendeeList
                                          key={attendee._id || index}
                                          attendee={attendee}
                                          getCartData={getCartData}
                                          eventId={props.eventId}
                                          ticketId={activeTicket.id}
                                          id={attendee._id}
                                          referralId={referralId}
                                        />
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="col-lg-4">
            <OrderSummamry
              attendeesLeft={attendeesLeft}
              navigateLink={redirectUrl}
              eventId={props.eventId}
              cart={cart.data}
              installment={installment}
              isShowSplitPayment={
                EventData?.settings?.settings?.splitPaymentEnabled
              }
              minSplitOrderAmount={
                EventData?.settings?.settings?.minSplitOrderAmount
              }
            />
          </div>
        </div>
      </div>
    </MainComponentWrapper>
  );
};

export default AttendeeInformation;
